export const PHONE_NUMBER: string = '8 (800) 302-47-48';
export const COMPANY_EMAIL: string = 'info@jurik.ru';
export const COMPANY_TELEGRAM_LINK: string = 'https://t.me/jurik_ru';
export const COMPANY_VK_LINK: string = 'https://vk.com/jurik_ru';
export const ROOT_URL_HOST: string = 'https://jurik.ru';
export const FOOTER_DESCRIPTION: string =
  'Юрик.ру — это надежная площадка, которая поможет найти проверенного юриста в вашем городе.';

export const EMBLEM_SRC: string = '/images/emblem.svg';
export const COMPANY_LEGAL_NAME: string = 'ООО «Лигал Адс Тех»';
export const COMPANY_PHONE_INTERNATIONAL: string = '+7-800-302-47-48';
export const COMPANY_ACCREDITATION_NUMBER: string = '31264';
export const LOGO_SRC: string = '/images/logo.svg';
